export default "__VITE_ASSET__Ct4TJ5Mg__"